import {
    Box,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { ProjectDetailDto, ProjectDto, ProjectService } from "../../../api/psc";
import { DialogContainer, DialogHeader } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogContext";
import { setProjectDetailVisibility } from "../../../slices/ProjectDetailSlice";
import { projectUpdatedAction } from "../../../slices/SharedActions";

export default function ProjectVisibilityDialog(props: {
    project: ProjectDto | ProjectDetailDto;
}) {
    const project = props.project;

    const dispatch = useDispatch();

    const [requestInProgress, setRequestInProgress] = useState<boolean>(false);
    const [isHidden, setIsHidden] = useState<boolean>(project.isHidden);

    const { closeDialog } = useContext(DialogContext);

    const handleChangeProjectVisibility = (
        event: React.MouseEvent<HTMLElement>,
        hidden: boolean
    ) => {
        if (hidden === null) {
            return;
        }

        setRequestInProgress(true);
        setIsHidden(hidden);

        ProjectService.batchUpdateProjectVisibility("1", {
            folderIdsHash: [project.hashId],
            hide: hidden,
        }).then((r) => {
            setRequestInProgress(false);
            closeDialog();
            dispatch(setProjectDetailVisibility(hidden));
            dispatch(projectUpdatedAction({ ...project, isHidden: hidden }));
        });
    };

    return (
        <DialogContainer>
            <DialogHeader title="وضعیت نمایش پروژه" />

            <Box sx={{ p: 2 }}>
                <Typography sx={{ mb: 2 }} color="text.secondary">
                    در صورتی که تمایل به مشاهده این پروژه در لیست خود ندارید
                    میتوانید از این بخش نسبت به عدم نمایش پروژه اقدام نمایید.
                </Typography>

                <ToggleButtonGroup
                    fullWidth
                    value={isHidden}
                    disabled={requestInProgress}
                    exclusive
                    onChange={handleChangeProjectVisibility}
                >
                    <ToggleButton value={false} color="success">
                        نمایش پروژه
                    </ToggleButton>

                    <ToggleButton value={true} color="error">
                        عدم نمایش پروژه
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>
        </DialogContainer>
    );
}
